import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import Slider from "react-slick";


const PlacementNewsComponent = () => {
  const [placements, setPlacements] = useState([]);
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch placements
        const placementsSnapshot = await getDocs(collection(firestore, "placements"));
        const placementsData = placementsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPlacements(placementsData);

        // Fetch news
        const newsSnapshot = await getDocs(collection(firestore, "news"));
        const newsData = newsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setNews(newsData);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div>Loading...</div>;

  const placementCarouselSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const newsCarouselSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false
  };

  return (
    <div className="placements-news-container">
      {/* Placement Section */}
      <div className="placements-section">
        <h3 className="sections-title" style={{ color: 'white' }}>Placements</h3>
        <div className="placements-slider-container">
          <Slider {...placementCarouselSettings}>
            {placements.map((placement) => (
              <div key={placement.id} className="placements-card">
                <img className="placement-image" src={placement.imageUrl} alt={placement.studentName} />
                <h4 className="student-name" style={{ color: 'white' }}>{placement.studentName}</h4>
                {placement.companyLogo ? (
                  <div className="company-logo-container" style={{ 
  marginTop: '12px', 
  display: 'flex', 
  justifyContent: 'center', 
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: '6px', // Reduced from 15px for more rectangular look
  padding: '2px 8px', // Changed to horizontal padding (left-right more than top-bottom)
  minHeight: '20px', // Slightly increased for better proportion
  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
  width: 'fit-content',
  margin: '12px auto'
}}>
  <img 
    className="company-logo" 
    src={placement.companyLogo} 
    alt={placement.companyName || 'Company Logo'} 
    style={{ 
      maxWidth: '80px', // Reduced from 120px for more minimal size
      maxHeight: '20px', // Reduced from 50px
      objectFit: 'contain' 
    }}
  />
</div>
                ) : placement.companyName ? (
                  <p className="company-name" style={{ color: '#ffd700', fontWeight: '600', marginTop: '5px' }}>
                    {placement.companyName}
                  </p>
                ) : null}
                {placement.course && (
                  <p className="course-name">{placement.course}</p>
                )}
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* News Section */}
      <div className="news-events-sections">
        <h3 className="sections-title" style={{ color: 'white' }}>News and Events</h3>
        <Slider {...newsCarouselSettings}>
          {news.map(({ id, title, description, date }) => {
            const newsDate = new Date(date);
            return (
              <div key={id} className="news-card">
                <div className="news-date">
                  <div className="news-date-day">{newsDate.getDate()}</div>
                  <div className="news-date-month">
                    {newsDate.toLocaleString('default', { month: 'short' }).toUpperCase()}
                  </div>
                  <div className="news-date-year">{newsDate.getFullYear()}</div>
                </div>
                <div className="news-content">
                  <h4 className="news-title">{title}</h4>
                  <p className="news-description">{description}</p>
                </div>
              </div>
            );
          })}
        </Slider>
        {/* <button className="news-archive-btn">NEWS ARCHIVE</button> */}
      </div>
    </div>
  );
};

export default PlacementNewsComponent;